/**
 * Controller for the modal that allows the invigilator to pause the candidate's task.
 * This class handles the logic for confirming the pause action and updating the relevant preferences.
 */
export default class InvigilatorMenuCandidateCanPauseModalController {
    /**
     * Constructs the controller instance.
     * 
     * @param {Object} $scope - AngularJS scope object.
     * @param {Object} $uibModalInstance - Instance of the modal dialog.
     * @param {Object} taskCountdownService - Service for managing task countdown.
     * @param {Object} $eventLog - Service for logging events.
     * @param {Object} iaaPreferences - Preferences related to the invigilator and candidate.
     * @param {Object} IAAPreferencesService - Service for managing IAA preferences.
     */
    constructor($scope, $uibModalInstance, taskCountdownService, $eventLog, iaaPreferences, IAAPreferencesService) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.taskCountdownService = taskCountdownService;
        this.$eventLog = $eventLog;
        this.iaaPreferences = iaaPreferences;
        this.IAAPreferencesService = IAAPreferencesService;

        this.iaaKey = 'candidateCanPause';

        // Initialize scope variables
        this.$scope.candidateCanPause = this.iaaPreferences[this.iaaKey];
        this.$scope.eventExplanation = '';
        this.$scope.eventTypeReason = '';

        // Bind methods
        this.$scope.onConfirm = this.onConfirm.bind(this);
    }

    /**
     * Handles the confirmation of the pause action.
     * This method toggles the candidate's ability to pause and updates the event explanation if provided.
     */
    onConfirm() {
        // Mark the modal instance as confirmed
        this.$uibModalInstance.result.confirm = true;

        // Get the explanation from the admin-event-type directive
        const explanation = this.$scope.eventExplanation;
        console.log('Got explanation:', explanation);

        // Set the explanation in the preferences service
        this.IAAPreferencesService.setEventExplanation(this.iaaKey, explanation || '');

        // Toggle the preference
        this.iaaPreferences[this.iaaKey] = !this.iaaPreferences[this.iaaKey];

        // Close the modal
        this.$uibModalInstance.close();
    }
}

InvigilatorMenuCandidateCanPauseModalController.$inject = [
    '$scope',
    '$uibModalInstance',
    'taskCountdownService',
    '$eventLog',
    'iaaPreferences',
    'IAAPreferencesService'
];